export const DATE_FORMAT = 'DD.MM.YYYY';
export const API_URL = process.env.REACT_APP_API_URL;
export const isDev = process.env.REACT_APP_ENV === 'development';
export const isStag = process.env.REACT_APP_ENV === 'staging';
export const isProd = process.env.REACT_APP_ENV === 'production';
